/**
 * EntityType is the type of entity the wallet identifier belongs to
 */
export var EntityType;
(function (EntityType) {
    EntityType["User"] = "user";
    EntityType["Reward"] = "reward";
})(EntityType || (EntityType = {}));
/**
 * `identifier` to be used when calling `flexi-points-app`.
 * call `identifier` to get a string representation of a wallet.
 *
 * ### Example (es module)
 * ```js
 * import { identifier, EntityType } from 'flexi-points'
 * console.log(identifier(EntityType.User, uuid(), 'RP'))
 * // => RP_user_319530b9-b449-40db-93b9-b5533dffb655
 * ```
 */
export const identifier = (wallet) => {
    return `${wallet.currency.toLowerCase()}_${wallet.entityType}_${wallet.entityId}`;
};
/**
 * `parse` for parsing ids from `flexi-points-app`.
 * call `parse` to get a breakdown of wallet values from an id string.
 *
 * ### Example (es module)
 * ```js
 * import { parse } from 'flexi-points'
 * console.log(parse('FP_user_319530b9-b449-40db-93b9-b5533dffb655'))
 * // => {entityType: "user", entityId: "FP_user_319530b9-b449-40db-93b9-b5533dffb655", currency: "FP"}
 * ```
 */
export const parse = (identifier) => {
    const split = identifier.split('_', 3);
    if (split.length < 3) {
        return new Error('invalid identifier format');
    }
    return {
        currency: split[0].toUpperCase(),
        entityId: split[2],
        entityType: split[1],
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2FsbGV0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi93YWxsZXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxVQUdYO0FBSEQsV0FBWSxVQUFVO0lBQ3BCLDJCQUFhLENBQUE7SUFDYiwrQkFBaUIsQ0FBQTtBQUNuQixDQUFDLEVBSFcsVUFBVSxLQUFWLFVBQVUsUUFHckI7QUFXRDs7Ozs7Ozs7OztHQVVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLENBQUMsTUFBYyxFQUFVLEVBQUU7SUFDbkQsT0FBTyxHQUFHLE1BQU0sQ0FBQyxRQUFRLENBQUMsV0FBVyxFQUFFLElBQUksTUFBTSxDQUFDLFVBQVUsSUFDMUQsTUFBTSxDQUFDLFFBQ1QsRUFBRSxDQUFDO0FBQ0wsQ0FBQyxDQUFDO0FBRUY7Ozs7Ozs7Ozs7R0FVRztBQUNILE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBRyxDQUFDLFVBQWtCLEVBQWtCLEVBQUU7SUFDMUQsTUFBTSxLQUFLLEdBQUcsVUFBVSxDQUFDLEtBQUssQ0FBQyxHQUFHLEVBQUUsQ0FBQyxDQUFDLENBQUM7SUFDdkMsSUFBSSxLQUFLLENBQUMsTUFBTSxHQUFHLENBQUMsRUFBRTtRQUNwQixPQUFPLElBQUksS0FBSyxDQUFDLDJCQUEyQixDQUFDLENBQUM7S0FDL0M7SUFFRCxPQUFPO1FBQ0wsUUFBUSxFQUFFLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxXQUFXLEVBQUU7UUFDaEMsUUFBUSxFQUFFLEtBQUssQ0FBQyxDQUFDLENBQUM7UUFDbEIsVUFBVSxFQUFFLEtBQUssQ0FBQyxDQUFDLENBQWU7S0FDbkMsQ0FBQztBQUNKLENBQUMsQ0FBQyJ9